import { controls, currencyToNumber, grouped } from "../../controls";

const rp8 = {
  label: "Matched By You",
  starting: true,
  url: "rp8",
  pageLabel: "Matched By You",
  pageType: "history",
  filter: [
    
 ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Matched By You",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    filterable: true,
    sortable: true,
    // defaultsTo: 0,
    pivot: true,
    extraRows: {
      location: "top",
      fields: [""],
    
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
     
      {
        Header: "Track_The_Child_Name",
        accessor: "tgc_name",
        rwidth: "*"
      },
      {
        Header: "Saral Id",
        accessor: "saral_id",
        
      },
      {
        Header: "Remark",
        accessor: "remark",
      
      },
      
     ]
  }
};

export default rp8;